export default {
      id: "ar-signalement-usage",
      viewBox: "0 0 125 125",
      url: "../dist/images/" + "sprite.svg#ar-signalement-usage",
      toString: function () {
        return this.url;
      }
    }